export default __webpack_public_path__ + "media/cms-bg.a8de2972.png";